// Select all drop-area elements
const dropAreas = document.querySelectorAll(".drop-area");

dropAreas.forEach((dropArea) => {
  // Get the file input and file list associated with this drop area
  const fileElem = dropArea.querySelector("input[type='file']");
  const fileList = dropArea.nextElementSibling; // This will get the file list div next to the drop-area

  // Prevent default drag behaviors
  ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
    dropArea.addEventListener(eventName, preventDefaults, false);
  });

  function preventDefaults(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  // Highlight the drop area when a file is dragged over
  ["dragenter", "dragover"].forEach((eventName) => {
    dropArea.addEventListener(
      eventName,
      () => dropArea.classList.add("highlight"),
      false
    );
  });

  ["dragleave", "drop"].forEach((eventName) => {
    dropArea.addEventListener(
      eventName,
      () => dropArea.classList.remove("highlight"),
      false
    );
  });

  // Handle dropped files
  dropArea.addEventListener("drop", (e) => handleDrop(e, fileList), false);

  // Open file input dialog when drop-area is clicked
  dropArea.addEventListener("click", () => fileElem.click(), false);

  // Handle file selection through browse button
  fileElem.addEventListener("change", (e) => {
    handleFiles(e.target.files, fileList);
  });

  // Handle dropped files or file input changes
  function handleDrop(e, fileList) {
    const files = e.dataTransfer.files;
    handleFiles(files, fileList);
  }

  function handleFiles(files, fileList) {
    fileList.innerHTML = ""; // Clear existing list before appending new files
    [...files].forEach((file) => {
      const fileItem = document.createElement("span");
      fileItem.textContent = file.name;
      fileList.appendChild(fileItem);
    });
  }
});

function handleModalSave(modalId, fileListId, formElementSelector, inputSelector) {
  const fileNameSpan = document.querySelector(`#${fileListId} span`);
  const fileInput = document.querySelector(inputSelector);

  if (fileNameSpan && fileInput) {
    const fileName = fileNameSpan.textContent.trim();
    const formElement = document.querySelector(formElementSelector);
    if (formElement) {
      formElement.setAttribute("data-title", fileName);
    }

    const hiddenFileInput = document.querySelector(
      `#${fileListId} input[type="file"]`
    );
    if (hiddenFileInput && hiddenFileInput.files.length > 0) {
      const selectedFile = hiddenFileInput.files[0];

      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(selectedFile);
      fileInput.files = dataTransfer.files;

      console.log("File input files after assignment:", fileInput.files);

      const changeEvent = new Event("change");
      fileInput.dispatchEvent(changeEvent);
    }
  }

  const modalElement = document.getElementById(modalId);
  if (modalElement) {
    modalElement.style.display = "none";
  }
}

document.querySelector(".edit-resume")?.addEventListener("click", function () {
	const heading = document.querySelector('#resumeModal .custom-modal-header h3');
    if (heading) {
        heading.textContent = 'Edit Resume';
    }
	if( document.querySelector(".resume-modal-message.failed-message") ) {
		document.querySelector(".resume-modal-message.failed-message").remove();
	}
});

document.querySelector(".edit-letter")?.addEventListener("click", function () {
	const heading = document.querySelector('#coverLetterModal .custom-modal-header h3');
    if (heading) {
        heading.textContent = 'Edit Cover Letter';
    }
	if( document.querySelector(".cv-modal-message.failed-message") ) {
		document.querySelector(".cv-modal-message.failed-message").remove();
	}
});

document.getElementById("saveResume")?.addEventListener("click", function () {
	// Remove the uploading message
	const existingMessage = document.querySelector('.resume-modal-message');
	if (existingMessage) existingMessage.remove();

  	const applicantId = document.getElementById("applicant_id").value;
  	const resumeFileInput = document.getElementById("uploadResumeFile");
   	const resumeFile = resumeFileInput.files[0];
	const resumeModalFooter = document.querySelector(".resume-modal-footer");
	
	if (resumeFile) {
		const maxSize = 5 * 1024 * 1024; // 5MB in bytes
        if (resumeFile.size > maxSize) {
			if (resumeModalFooter) {
				let messageDiv = document.createElement('div');
				messageDiv.className = 'resume-modal-message failed-message';
				messageDiv.innerHTML = 'File size exceeds 5MB. Please upload a smaller file.';
				resumeModalFooter.parentNode.insertBefore(messageDiv, resumeModalFooter);
			}
        } else {
			const saveBtn = document.getElementById("saveResume");
			const cancelBtn = document.getElementById("cancelResume");

			const formData = new FormData();
			formData.append('action', 'applicant_upload_resume');
			formData.append("resume", resumeFile);
			formData.append("user_id", applicantId);
			formData.append('upload_resume_nonce', ajax_callback_data.ajax_nonce);

			let uploadingMessage = document.createElement('div');
			uploadingMessage.className = 'resume-modal-message uploading-message';
			uploadingMessage.textContent = "Uploading resume...";
			if (resumeModalFooter) {
				resumeModalFooter.parentNode.insertBefore(uploadingMessage, resumeModalFooter);
				saveBtn.disabled = true;
				cancelBtn.disabled = true;
			}

			fetch(ajax_callback_data.ajax_url, {
					method: "POST",
					body: formData
			})
			.then(response => response.json())
			.then(data => {
				// Remove the uploading message
				const existingMsg = document.querySelector('.uploading-message');
				if (existingMsg) existingMsg.remove();
				document.querySelector('.delete-resume').classList.remove('d-none');
				document.querySelector('#uploaded-resume').value = 1;

				// Re-enable buttons
				saveBtn.disabled = false;
				cancelBtn.disabled = false;

				if (data.success) {
					handleModalSave("resumeModal", "resumeFileList", ".form-element--resume .form-element-file", "#resumeFile");

				} else {
					if (resumeModalFooter) {
						let messageDiv = document.createElement('div');
						messageDiv.className = 'resume-modal-message failed-message';
						messageDiv.innerHTML = data.data.message;
						resumeModalFooter.parentNode.insertBefore(messageDiv, resumeModalFooter);
					}
				}
			})
			.catch(error => {
					console.error("Error uploading file:", error);
			});
		}
	} else {
		if (resumeModalFooter) {
			let messageDiv = document.createElement('div');
			messageDiv.className = 'resume-modal-message failed-message';
			messageDiv.innerHTML = "<span>No resume file selected</span>";
			resumeModalFooter.parentNode.insertBefore(messageDiv, resumeModalFooter);
		}
	}
});

document.getElementById("saveCoverLetter")?.addEventListener("click", function () {
	// Remove the uploading message
	const existingMessage = document.querySelector('.cv-modal-message');
	if (existingMessage) existingMessage.remove();

  	const applicantId = document.getElementById("applicant_id").value;
  	const cvFileInput = document.getElementById("uploadCoverLetterFile");
   	const cvFile = cvFileInput.files[0];
	const cvModalFooter = document.querySelector(".cv-modal-footer");

	if (cvFile) {
		const maxSize = 5 * 1024 * 1024; // 5MB in bytes
        if (cvFile.size > maxSize) {
			if (cvModalFooter) {
				let messageDiv = document.createElement('div');
				messageDiv.className = 'cv-modal-message failed-message';
				messageDiv.innerHTML = 'File size exceeds 5MB. Please upload a smaller file.';
				cvModalFooter.parentNode.insertBefore(messageDiv, cvModalFooter);
			}
        } else {
			const saveBtn = document.getElementById("saveCoverLetter");
			const cancelBtn = document.getElementById("cancelCv");

			const formData = new FormData();
			formData.append('action', 'applicant_upload_cv');
			formData.append("cv", cvFile);
			formData.append("user_id", applicantId);
			formData.append('upload_cv_nonce', ajax_callback_data.ajax_nonce);

			let uploadingMessage = document.createElement('div');
			uploadingMessage.className = 'cv-modal-message uploading-message';
			uploadingMessage.textContent = "Uploading cover letter...";
			if (cvModalFooter) {
				cvModalFooter.parentNode.insertBefore(uploadingMessage, cvModalFooter);
				saveBtn.disabled = true;
				cancelBtn.disabled = true;
			}

			fetch(ajax_callback_data.ajax_url, {
					method: "POST",
					body: formData
			})
			.then(response => response.json())
			.then(data => {
				// Remove the uploading message
				const existingMsg = document.querySelector('.uploading-message');
				if (existingMsg) existingMsg.remove();
				document.querySelector('.delete-letter').classList.remove('d-none');
				document.querySelector('#uploaded-cv').value = 1;

				// Re-enable buttons
				saveBtn.disabled = false;
				cancelBtn.disabled = false;

				if (data.success) {
					handleModalSave("coverLetterModal", "coverLetterList", "#resumeCoverLetter", "#coverLetterInputFile");

				} else {
					if (cvModalFooter) {
						let messageDiv = document.createElement('div');
						messageDiv.className = 'cv-modal-message failed-message';
						messageDiv.innerHTML = data.data.message;
						cvModalFooter.parentNode.insertBefore(messageDiv, cvModalFooter);
					}
				}
			})
			.catch(error => {
					console.error("Error uploading file:", error);
			});
		}
	} else {
		if (cvModalFooter) {
			let messageDiv = document.createElement('div');
			messageDiv.className = 'cv-modal-message failed-message';
			messageDiv.innerHTML = "<span>No cv file selected</span>";
			cvModalFooter.parentNode.insertBefore(messageDiv, cvModalFooter);
		}
	}
});

// function to delete resume and cover letter
function handleFileDelete(deleteButtonClass, formElementSelector, fileListId) {
	document.querySelectorAll(deleteButtonClass).forEach((button) => {
		button.addEventListener("click", function () {
			// Get the parent form element
			const formElement = this.closest(formElementSelector);

			if (formElement) {
				// Reset the file input
				const fileInput = formElement.querySelector('input[type="file"]');
				if (fileInput) {
					fileInput.value = ""; // Clear the selected file
				}

				// Clear the data-title attribute
				if ( formElement.id === "resumeFile" ) {
					formElement.setAttribute("data-title", "Upload resume");
					document.querySelector('.delete-resume').classList.add('d-none');
					document.querySelector('#uploaded-resume').value = 0;
				}
				if ( formElement.id === "resumeCoverLetter" ) {
					formElement.setAttribute("data-title", "Upload cover letter");
					document.querySelector('.delete-letter').classList.add('d-none');
					document.querySelector('#uploaded-cv').value = 0;
				}

				// Clear the file-list UI in modal
				const fileList = document.getElementById(fileListId);
				if (fileList) {
					fileList.innerHTML = "";
					const applicantId = document.getElementById("applicant_id").value;

					// remove uploaded resume file
					if( fileListId == 'resumeFileList' ) {
						const formData = new FormData();
						formData.append('action', 'delete_applicant_resume');
						formData.append('delete_resume_nonce', ajax_callback_data.ajax_nonce);
						formData.append('user_id', applicantId);
				  
						fetch(ajax_callback_data.ajax_url, {
						  method: 'POST',
						  body: formData,
						})
						.then((response) => response.json())
						.then((data) => {
							if (data.success) {
								document.getElementById('resumeFileList').innerHTML = '';
							} else {
								alert(data.data.message);
							}
						})
						.catch((error) => {
							console.error('Delete error:', error);
						});
					}
					
					// remove uploaded cv file
					if( fileListId == 'coverLetterList' ) {
						const formData = new FormData();
						formData.append('action', 'delete_applicant_cv');
						formData.append('delete_cv_nonce', ajax_callback_data.ajax_nonce);
						formData.append('user_id', applicantId);
				  
						fetch(ajax_callback_data.ajax_url, {
						  method: 'POST',
						  body: formData,
						})
						.then((response) => response.json())
						.then((data) => {
							if (data.success) {
								document.getElementById('coverLetterList').innerHTML = '';
							} else {
								alert(data.data.message);
							}
						})
						.catch((error) => {
							console.error('Delete error:', error);
						});
						
					}

				}
			}
		});
	});
}

// Initialize delete functionality when DOM is loaded
document.addEventListener("DOMContentLoaded", function () {
  // Handle resume deletion
  handleFileDelete(".delete-resume", ".form-element--resume .form-element-file", "resumeFileList");

  // Handle cover letter deletion
  handleFileDelete(".delete-letter", ".form-element--cover-letter .form-element-file", "coverLetterList");
});
